import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, ApiKaspiPricesService, ApiProductsService, ValidatorsService } from 'src/app/services';
import { KaspiPriceCreateValidator } from './kaspi-price-create.validators';


@Component({
  selector: 'app-kaspi-price-create',
  templateUrl: './kaspi-price-create.component.html',
  styleUrls: ['./kaspi-price-create.component.css']
})
export class KaspiPriceCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  products: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  errorMessages: any;

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    offers: this.fb.array([]),
  });


  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiKaspiPrices: ApiKaspiPricesService,
    private apiProducts: ApiProductsService,
    private notification: NotificationService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private validator: KaspiPriceCreateValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.getProducts();
    this.addOffer();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param searchValue 
   */
  getProducts(searchValue: string = ''): void {

    let params: ReferenceParams = {
      filter: {
        name: searchValue
      }
    }

    this.loading = true;
    this.products = [];

    this.subscriptions.add(
      this.apiProducts.getReferences(params, 'products').subscribe((response: Res) => {
        console.log('[RESPONSE] getProducts: ', response);

        if (response != null) {

          let list: any[] = [];
          let offers: any[] = this.form.get('offers').value;

          for (let prod of response.result) {

            if (offers.findIndex(val => val.product_id == prod.id) == -1) {

              list.push({ ...prod });
            }
          }

          this.products = [...list];
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
          this.products = [];
        })
    );
  }


  /* OFFERS */

  /**
  * 
  * @param type string
  */
  addOffer(): void {

    let control = this.form.controls.offers as UntypedFormArray;
    control.insert(0, this.initOffer()); // insert 0 - вставка в начала массива / push - вставка в конец массива
    this.addAvailability(0);
  }

  /**
   * 
   * @returns 
   */
  initOffer(): any {

    return this.fb.group({
      id: [null],
      product_id: ['', this.validator.product_id],
      availabilities: new UntypedFormArray([]),
      price: ['', this.validator.price]
    });
  }

  /**
   * 
   * @param i number
   */
  removeOffer(i: number): void {

    let control = this.form.controls.offers as UntypedFormArray;
    control.removeAt(i);

    this.getProducts();
  }



  /* AVAILABILITY */

  /**
   * 
   * @param type string
   */
  addAvailability(index: number): void {

    let control = this.form.get(['offers', index, 'availabilities']) as UntypedFormArray;
    control.push(this.initAvailability(index));
  }

  /**
  * 
  */
  initAvailability(index: number): any {

    return this.fb.group({
      available: 'yes',
      storeId: 'pp' + (this.form.get(['offers', index, 'availabilities']).value.length + 1)
    });
  }

  /**
  * 
  * @param i number
  */
  removeAvailability(i: number, j: number): void {

    let control = this.form.get(['offers', i, 'availabilities']) as UntypedFormArray;
    control.removeAt(j);
  }

  /* VALIDATION */

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }


  /**
   * 
   */
  onCreate() {

    this.progressRef.start();

    let data = { ...this.form.value };

    for (let offer of data.offers) {

      offer.price = +offer.price;
    }

    this.subscriptions.add(
      this.apiKaspiPrices.save(data).subscribe((response: Res) => {

        if (response != null) {

          this.router.navigate(['export', 'integrations', 'kaspi']);
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

}
